
define('esteira-locacao-controller',[
    'esteira-locacao-resource',
    'directive/ng-flow/dist/ng-flow-standalone.min',
    'directive/flow.js/dist/flow.min',
    'directive/ng-flow/dist/ng-flow.min',
    'angular-file-upload',


], function () {

    var app = angular.module('esteira.locacao.controller', [
        'esteira.locacao.resource',
        'ui.mask',
        'flow',
        'ui.select',

    ]);

    app.controller('EsteiraLocacaoControllerIndex', ['$scope', '$rootScope', 'EsteiraLocacao', '$mdDialog', '$location', '$window', function ($scope, $rootScope, EsteiraLocacao, $mdDialog, $location, $window) {
        $scope.esteiras = esteiras;
        $scope.showFormChaves = false;
        let currentDate = new Date();
        currentDate.setSeconds(0);
        currentDate.setMilliseconds(0);
        $scope.dataRetirada = currentDate;
        $scope.statusDocs = (esteira) => {
            let qtd = 0;
            qtd = esteira.Documentos.length;
            if (qtd == 0) return 'Pendente';
            if (esteira.es_contrato_gerado) return 'Concluído';
            return 'Em andamento';
        }

        $scope.agendarRetiradaChaves = (esteira) => {
            return (!esteira.es_chaves_entregues && esteira.es_contrato_assinado && esteira.es_agendamento_chaves_aceito == null && esteira.es_data_agendamento_chaves == null);
        };

        $scope.aguardandoRespostaChaves = (esteira) => {
            return (!esteira.es_chaves_entregues && esteira.es_contrato_assinado && esteira.es_agendamento_chaves_aceito == null && esteira.es_data_agendamento_chaves);
        };

        $scope.agendamentoNegadoChaves = (esteira) => {
            return (!esteira.es_chaves_entregues && esteira.es_contrato_assinado && esteira.es_agendamento_chaves_aceito === false && esteira.es_data_agendamento_chaves);
        };

        $scope.agendamentoAprovadoChaves = (esteira) => {
            return (esteira.es_agendamento_chaves_aceito && !esteira.es_chaves_entregues);
        };


        $scope.formatDate = (inputDate) => {
            const date = new Date(inputDate);

            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so we add 1.
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');

            const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;

            return formattedDate;

        }
        $scope.toggleFormChaves = (esteira, event) => {
            $scope.esteiraAtual = esteira;
            if (event) event.stopPropagation(); // Stop the event from propagating to the parent div
            $scope.showFormChaves = !$scope.showFormChaves;
        };


        $scope.saveDataRetirada = () => {
            let payload = $scope.esteiraAtual;
            payload.es_data_agendamento_chaves = $scope.dataRetirada;

            EsteiraLocacao.retirarChavesEsteira(payload).then((result) => {
                $scope.esteiraAtual.es_data_agendamento_chaves = $scope.dataRetirada;
                $scope.showFormChaves = false;
            }).catch(err => {
                alert('Não foi possível salvar a data selecionada. Tente novamente');
            });

        }


        $scope.gotoDocs = (es_codigo) => {
            $window.location.href = `/esteiraform/documentos/${es_codigo}`;
        };


    }]);

    app.controller('EsteiraLocacaoControllerAdd', ['$scope', '$rootScope', 'EsteiraLocacao', '$mdDialog', '$location', '$window',
        function ($scope, $rootScope, EsteiraLocacao, $mdDialog, $location, $window) {
            $scope.pagina = 'Esteira de Locação';
            $scope.imovel = imovel;
            $scope.pessoa = pessoa;
            $scope.garantias = garantias;
            $scope.segmentos = segmentos;
            $scope.form = {};
            if ($scope.pessoa.pes_tipopessoa == 'F') {
                $scope.selected = 'PF';
                $scope.form.cpf = $scope.pessoa.cpfcnpj;
                $scope.form.pes_rg = $scope.pessoa.rginsmunicipal;

                if ($scope.pessoa.pes_datanacimento) {
                    $scope.form.pes_datanacimento = $scope.pessoa.pes_datanacimento.substring(0, 10);

                    document.getElementById("dataNasc").type = 'date';
                }

                if ($scope.pessoa.profseg) {
                    EsteiraLocacao.getProfissoes($scope.pessoa.profseg).then(profs => {
                        $scope.form.profissao = profs.profession[0];
                    })
                }

                if ($scope.pessoa.estadocivil) {
                    $scope.form.pes_estadocivil = $scope.pessoa.estadocivil;
                }
            }



            if ($scope.pessoa.pes_tipopessoa == 'J') {
                $scope.selected = 'PJ';
                $scope.form.cnpj = $scope.pessoa.cpfcnpj;
                if ($scope.pessoa.pes_datafundacao) {
                    $scope.form.pes_datanacimento = $scope.pessoa.pes_datanacimento.substring(0, 10);
                    document.getElementById("dataNasc").type = 'date';
                }

                if ($scope.pessoa.profseg) {
                    $scope.form.segmento = $scope.segmentos.find(obj => obj.seg_nome === $scope.pessoa.profseg);
                }
            }







            $scope.estadosCivis = [{
                pes_estadocivil: 'S',
                nome: 'Solteiro(a)'
            },
            {
                pes_estadocivil: 'C',
                nome: 'Casado(a)'
            },
            {
                pes_estadocivil: 'D',
                nome: 'Divorciado(a)'
            },
            {
                pes_estadocivil: 'V',
                nome: 'Viuvo(a)'
            },
            {
                pes_estadocivil: 'P',
                nome: 'Separado(a)'
            },
            {
                pes_estadocivil: 'Q',
                nome: 'Desquitado(a)'
            },
            {
                pes_estadocivil: 'U',
                nome: 'União Estável'
            },
            {
                pes_estadocivil: 'N',
                nome: 'N.D.A.'
            }
            ];

            EsteiraLocacao.getProfissoes().then(profs => {
                $scope.profissoes = profs.profession;
            })




            let currentTab = 0; // Current tab is set to be the first tab (0)
            showTab(currentTab); // Display the current tab

            function showTab(n) {
                // This function will display the specified tab of the form ...
                var x = document.getElementsByClassName("tab");
                x[n].style.display = "block";
                // ... and fix the Previous/Next buttons:
                if (n == 0) {
                    document.getElementById("prevBtn").style.display = "none";
                } else {
                    document.getElementById("prevBtn").style.display = "inline";
                }
                if (n == (x.length - 1)) {
                    document.getElementById("nextBtn").innerHTML = "Salvar";
                } else {
                    document.getElementById("nextBtn").innerHTML = "Continuar";
                }
                // ... and run a function that displays the correct step indicator:
                fixStepIndicator(n)
            }

            $scope.nextPrev = function (n) {
                var x = document.getElementsByClassName("tab");
                if (n === 1 && !validateForm()) return false;
                if (n === 1 && currentTab >= x.length-1) {
                    submitForm();
                    return false;
                }
                x[currentTab].style.display = "none";
                currentTab = currentTab + n;
                
                // Otherwise, display the correct tab:
                showTab(currentTab);
            }

            function validateForm() {
                let x, y, i, valid = true;
                x = document.getElementsByClassName("tab");
                y = x[currentTab].querySelectorAll("input, select, textarea");
                y = Array.from(y).filter(function (element) {
                    return element.id !== "profSearch" && element.id != 'Observação';
                });
                // A loop that checks every input field in the current tab:
                for (i = 0; i < y.length; i++) {
                    y[i].classList.remove("invalid");
                    if (y[i].tagName.toLowerCase() === "select") {
                        if (y[i].selectedIndex === 0) { // No option selected
                            y[i].classList.add("invalid");
                            valid = false;
                        }
                    } else if (y[i].value.trim() === "") { // Check for input and textarea elements
                        y[i].classList.add("invalid");
                        valid = false;
                    }
                }

                if (!validaCPF($scope.form.cpf)) {
                    valid = false;
                    document.getElementById("cpf").classList.add("invalid");
                }

                // If the valid status is true, mark the step as finished and valid:
                if (valid) {
                    document.getElementsByClassName("step")[currentTab].classList.add("finish");
                }
                return valid; // return the valid status
            }

            function submitForm() {

                if ($scope.form.es_data_inicio >= $scope.form.es_data_fim) {
                    alert('Data de início não pode ser maior que a data de termino');
                    return false;
                }


                let es = $scope.estadosCivis.find(obj => obj.nome === $scope.form.pes_estadocivil);


                $scope.form.pes_tipopessoa = $scope.pessoa.pes_tipopessoa;
                if ($scope.pessoa.pes_tipopessoa == 'J') {
                    let seg = $scope.segmentos.find(obj => obj.seg_nome === $scope.form.segmento);
                    $scope.form.seg_codigo = seg.seg_codigo;
                    $scope.form.pes_datafundacao = $scope.form.pes_datanacimento;
                }

                $scope.form.pes_estadocivil = es.pes_estadocivil;

                $scope.form.imo_codigo = imovel.imo_codigo;
                $scope.form.pes_codigo = pessoa.pes_codigo;
                $scope.form.prof_codigo = $scope.form.profissao.prof_codigo;

                

                EsteiraLocacao.createEsteira($scope.form).then(data => {
                    if (data.success) {
                        $window.location.href = `/esteiraform/documentos/${data.esteira.es_codigo}`;
                    }


                });


                // document.getElementById("regForm").submit();
            }

            function fixStepIndicator(n) {
                // This function removes the "active" class of all steps...
                var i, x = document.getElementsByClassName("step");
                for (i = 0; i < x.length; i++) {
                    x[i].className = x[i].className.replace(" active", "");
                }
                //... and adds the "active" class to the current step:
                x[n].className += " active";
            }




            $scope.toggleDropdown = function () {
                document.getElementById("myDropdown").classList.toggle("show");
            }

            $scope.filterFunction = function (event) {
                let input, filter;
                input = document.getElementById(event.target.id);
                filter = input.value.toLowerCase();
                EsteiraLocacao.getProfissoes(filter).then(profs => {
                    $scope.profissoes = profs.profession;
                })
            }

            $scope.selectProfissao = (prof) => {
                $scope.form.profissao = prof;
                document.getElementById("myDropdown").classList.toggle("show");
            }

            $scope.testCpf = (strCPF) => {
                if (!validaCPF(strCPF)) {
                    alert('Cpf inválido');
                }
                return true;
            }

            function validaCPF(strCPF) {
                var Soma;
                var Resto;
                Soma = 0;
                if (strCPF && strCPF.length != 11) return false;
                if (strCPF == "00000000000") return false;

                for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
                Resto = (Soma * 10) % 11;

                if ((Resto == 10) || (Resto == 11)) Resto = 0;
                if (Resto != parseInt(strCPF.substring(9, 10))) return false;

                Soma = 0;
                for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
                Resto = (Soma * 10) % 11;

                if ((Resto == 10) || (Resto == 11)) Resto = 0;
                if (Resto != parseInt(strCPF.substring(10, 11))) {
                    alert('Cpf inválido');
                    return false;
                }
                return true;
            }
        }]);

    app.controller('EsteiraLocacaoControllerEdit', ['$scope', '$rootScope', 'EsteiraLocacao', '$mdDialog', '$window', function ($scope, $rootScope, EsteiraLocacao, $mdDialog, $window) {

        $scope.itens = itensjs;
        $scope.documentos = documentos;
        $scope.esteira = esteira;
        $scope.newDocs = [];
        $scope.showFormFiador = false;
        $scope.showDocsFiador = false;


        $scope.docNegado = (item) => {
            if ($scope.documentos.some(element => element.acoi_codigo == item.acoi_codigo && element.ed_status.toLowerCase().includes('negado'))) {
                return true;
            }
            return false;
        };




        $scope.toggleSection = function (item) {
            item.open = !item.open;
        };


        $scope.fileAdded = function ({ file, $flow, item, fiador }) {
            file.flowObj.files = [];
            $flow.files = [file];
            if (!file.file.type.startsWith('image/') && !file.file.type.startsWith('application/pdf')) {
                $scope.msgError = 'Apenas imagens e pdf são aceitos'
                $scope.showError = true;
                return;
            }
            $scope.showError = false;
            $scope.submitFlow({ $flow: $flow, item: item, fiador: fiador });
        };


        $scope.submitFlow = function ({ $flow, item, fiador }) {
            // let query = $scope.contestacao;
            $flow.files = $flow.files.filter(function (file) {
                return (file.file.type.startsWith('image/') || file.file.type.startsWith('application/pdf'));
            });

            $scope.totalFiles = $flow.files.length; // limitando upload de arquivos
            if ($scope.totalFiles > 1) $scope.totalFiles == 1;

            $flow.opts.target = `/esteiraform/documentos/save/${$scope.esteira.es_codigo}`;
            // $flow.opts.chunkSize = 1024*1024; //pra testar local
            $flow.opts.forceChunkSize = true;
            $flow.opts.query = Object.assign({}, item, fiador);

            $flow.upload();

        };



        $scope.uploadComplete = function ({ $flow, fiador }) {
            $flow.files.length = 0;
            $scope.showContestacao = false;
            if (fiador) {
                EsteiraLocacao.getDocumentosFiador({ esteira_id: $scope.esteira.es_codigo, fiador_id: fiador.ef_codigo }).then(docsFiador => {
                    $scope.fiador.Itens = docsFiador;
                });
                return;
            }
            EsteiraLocacao.getDocumentosEsteira($scope.esteira.es_codigo).then(documentos => {
                $scope.documentos = documentos;
            });
        };


        $scope.getIconClass = function (file) {
            // Define mapping of file types to icon classes
            if (!file) file = '.';
            var iconClasses = {
                pdf: 'fa-file-pdf',
                jpg: 'fa-file-image',
                // Add more file type mappings as needed
            };
            return iconClasses[file.split('.').pop()] || 'fa-file-o'; // Default icon class
        };


        $scope.deleteDocEsteira = function (documento) {
            EsteiraLocacao.deleteDocEsteira(documento).then(result => {
                $scope.documentos = result;
            });
        };


        // fiador VVVVVVVVVV



        $scope.docNegadoFiador = (item) => {
            if ($scope.fiador.Itens) {
                let fiadorItem = $scope.fiador.Itens.find(acoi => acoi.acoi_codigo == item.acoi_codigo);
                if (fiadorItem && fiadorItem.DocumentosFiador.some(element => element.acoi_codigo == item.acoi_codigo && element.edf_status.toLowerCase().includes('negado'))) {
                    return true;
                }
            }
            return false;
        };





        $scope.toggleFormFiador = () => {
            if ($scope.showFormFiador) resetFiador();

            $scope.showFormFiador = !$scope.showFormFiador;
        };

        $scope.toggleDocsFiador = (fiador) => {
            if (!$scope.showDocsFiador) $scope.fiador = fiador;
            $scope.showDocsFiador = !$scope.showDocsFiador;

            $scope.itens.forEach(obj => {
                obj.open = false;
            });

        };








        $scope.deleteFiador = function (fiador, event) {
            event.stopPropagation();
            EsteiraLocacao.deleteFiador(fiador).then(result => {
                if (result.success) {
                    $scope.esteira.Fiadores = $scope.esteira.Fiadores.filter(item => item !== fiador);
                }
            });
        };

        $scope.deleteDocFiador = function (documento) {
            EsteiraLocacao.deleteDocFiador(documento).then(result => {
                $scope.fiador.Itens = result;
            });
        };


        function resetFiador() {
            $scope.fiador = { profissao: {}, endereco: {} };
        };

        resetFiador();

        $scope.testCpf = (strCPF) => {
            if (!validaCPF(strCPF)) {
                alert('Cpf inválido');
                return false;
            }
            return true;
        }

        function validaCPF(strCPF) {
            var Soma;
            var Resto;
            Soma = 0;
            if (strCPF && strCPF.length != 11) return false;
            if (strCPF == "00000000000") return false;

            for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(strCPF.substring(9, 10))) return false;

            Soma = 0;
            for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(strCPF.substring(10, 11))) {
                alert('Cpf inválido');
                return false;
            }
            return true;
        }



        EsteiraLocacao.getProfissoes().then(profs => {
            $scope.profissoes = profs.profession;
        })


        $scope.toggleDropdown = function () {
            document.getElementById("myDropdown").classList.toggle("show");
        }

        $scope.filterFunction = function (event) {
            let input, filter;
            input = document.getElementById(event.target.id);
            filter = input.value.toLowerCase();
            EsteiraLocacao.getProfissoes(filter).then(profs => {
                $scope.profissoes = profs.profession;
            })
        }

        $scope.selectProfissao = (prof) => {
            $scope.fiador.profissao = prof;
            document.getElementById("myDropdown").classList.toggle("show");
        }


        $scope.getAddr = () => {
            EsteiraLocacao.getEnderecoPorCep($scope.fiador.endereco.cep).then(result => {
                if (result.Cidade) {
                    $scope.fiador.endereco.cidade = result.Cidade.cid_nome;
                    $scope.fiador.ef_cidade_codigo = result.Cidade.cid_codigo;
                    $scope.fiador.ef_cep = result.cep;
                    if (result.Cidade.Estado) $scope.fiador.endereco.estado = result.Cidade.Estado.est_nome;
                    if (result.bairro) $scope.fiador.endereco.bairro = result.bairro;
                    if (result.endereco) $scope.fiador.endereco.endereco = result.endereco;
                }
            });
        }

        $scope.validateForm = (form) => {
            $scope.resolveCaptcha = !$scope.responserecaptcha ? false : true;
            if (form.$valid) {
                $scope.validForm = true;
                return true;
            } else {
                $scope.validForm = false;
                angular.forEach(form.$error.required, function (value, key) {
                    console.log(form.$error.required[key]);
                    form.$error.required[key].$pristine = false;
                });
                return false;
            };
        };

        $scope.saveFiador = (formFiador=null) => {
            if (formFiador) {
                if (!$scope.validateForm(formFiador)) return;
            };

            if (!$scope.testCpf($scope.fiador.cpf)) {
                return;
            }

            let newFiador = {
                es_codigo: $scope.esteira.es_codigo,
                ef_nome: $scope.fiador.nome,
                ef_cpf: $scope.fiador.cpf,
                ef_rg: $scope.fiador.rg,
                ef_email: $scope.fiador.email,
                ef_telefone: $scope.fiador.telefone,
                ef_comentario: $scope.fiador.comentario,
                ef_cep: $scope.fiador.ef_cep,
                ef_cidade_codigo: $scope.fiador.ef_cidade_codigo,
                ef_bairro: $scope.fiador.endereco.bairro,
                ef_endereco: $scope.fiador.endereco.endereco,
                ef_numero: $scope.fiador.endereco.numero,
                ef_complemento: $scope.fiador.endereco.complemento,
                ef_profissao_codigo: $scope.fiador.profissao.prof_codigo
            };

            EsteiraLocacao.saveFiador(newFiador).then(result => {
                if (result.success) {
                    $scope.esteira.Fiadores.push(result.fiador);
                };
                $scope.showFormFiador = false;
                resetFiador();
            });
        };



        $scope.concluirDocumentacao = () => {
            let str = 'Alguns documentos estão pendentes: ';
            let pendente = false;
            for (i of $scope.itens) {
                if (!$scope.documentos.some(element => element.acoi_codigo == i.acoi_codigo)) {
                    str += `${i.acoi_nome}, `;
                    pendente = true;
                }

            }
            if (pendente) {
                str = str.slice(0, -2);
                str += '.';
                alert(str);
                return;
            }
            EsteiraLocacao.sendEmailDocEnviado($scope.esteira.es_codigo).then(() => {
                alert(' Agora é só aguardar o nosso retorno. Mantenha um olho no seu e-mail e acesse regularmente a sua área do cliente');
                $window.location.href = `/locacaodigital`;

            })
        }










    }]);






});

